<template>
	<v-card-text class="details">
		<div
			class="details__row"
			v-for="(value, key) in usersInfo"
			:key="key"
			v-show="value"
		>
			<div class="details__cell details__cell--key">{{ key }}:</div>
			<div class="details__cell details__cell--value">
				<span v-if="key === 'Contact Phone'">{{ value | phone }}</span>
				<span v-else>{{ value }}</span>
			</div>
		</div>
	</v-card-text>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
	data() {
		return {
			dataPoints: {
				"Syteline ID": "erp_id",
				Email: "email",
				"Contact Phone": "phone",
				"Company Name": "company",
				Address: "address",
				"Address Line 2": "address2",
				Country: "country_code",
				"Business Partner Id": "business_partner_id",
				City: "city",
				State: "state",
				"Zip Code": "zip",
				Role: "role.name",
				Supervisor: "parent.name",
				Modifier: "modifier",
				"Stock Wire Rope Hoist - Modifier": "rope_hoist_modifier",
				"Permission Groups": {
					field: "permission_groups",
					transform: groups => groups.map(({ name }) => name)
				}
			}
		};
	},

	props: {
		id: {
			default: null
		},

		user: {
			default: false
		}
	},

	computed: {
		usersInfo() {
			let data = {};

			_.forEach(this.dataPoints, (field, name) => {
				let transformFn = null;
				if (_.isPlainObject(field)) {
					transformFn = field.transform;
					field = field.field;
				}

				let value = this.getObjectValue(field, this.user);

				if (transformFn) {
					value = transformFn(value);
				}

				if (_.isArray(value)) {
					value = value.join(", ");
				}

				data[name] = value;
			});

			return data;
		}
	}
};
</script>
